export default {
	mounted(){
		this.$store.dispatch('AppBlog/getBlogs');
	},
	computed:{
		blogs(){        
      return this.$store.state.AppBlog;
    }
	}
}